module.exports = __webpack_public_path__ + "static/img/Isaac_Smith_desktop.103aaa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac_Smith_desktop.jpg
// module id = VAKk
// module chunks = 0